import { request } from "../../base";
import type { LeadMessagesData, Message } from "./types";

export const crmMessagesApi = {
	async getLeadMessages(proId: string, leadId: number) {
		return request<LeadMessagesData>(
			`/api/pro/${proId}/crm/leads/${leadId}/messages`,
		);
	},

	async sendLeadMessage(proId: string, leadId: number, body: string) {
		return request<Message>(
			`/api/pro/${proId}/crm/leads/${leadId}/messages`,
			{ method: "POST", body: { body } },
		);
	},
};
